import { useMemo } from 'react';

import { getFormatFunc, getMaskOptions, getMaskRemovalFunc } from '../utils/helpers';

export const useMaskFormattingTools = (mask: string) => {
    const maskOptions = useMemo(() => getMaskOptions(mask), [mask]);
    const formatValue = useMemo(() => getFormatFunc(maskOptions), [maskOptions]);
    const removeMaskNumbersAfterDeletedSymbol = useMemo(
        () => getMaskRemovalFunc(maskOptions),
        [maskOptions]
    );

    return {
        maskOptions,
        formatValue,
        removeMaskNumbersAfterDeletedSymbol,
    };
};
